/*
 * Product card hover video
 * -----------------------------------------------------------------------------
 * Plays a card's <video> on mouse enter and resets it on leave.
 * Framing match vs the still is handled by delivering both as 3:4
 * (see outfit-composer-card.liquid + card_hover_video Cloudinary transforms).
 */
(function () {
  'use strict';

  if (window.__ayamiProductCardHoverVideo) return;
  window.__ayamiProductCardHoverVideo = true;

  var reduceMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bindCard(card) {
    if (card.dataset.hoverVideoBound === 'true') return;
    var video = card.querySelector('.card__media video');
    if (!video) return;
    card.dataset.hoverVideoBound = 'true';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted = true;
    video.loop = true;

    function play() {
      if (reduceMotion) return;
      card.classList.add('is-hovering');
      if (video.readyState < 2) video.load();
      try {
        video.currentTime = 0;
      } catch (e) {}
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          card.classList.remove('is-hovering');
        });
      }
    }

    function stop() {
      card.classList.remove('is-hovering');
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    card.addEventListener('mouseenter', play);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', function (e) {
      if (!card.contains(e.relatedTarget)) stop();
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-product-card-hover-video]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (typeof MutationObserver === 'function') {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-product-card-hover-video]')) bindCard(n);
          else if (n.querySelectorAll) init(n);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
